import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const menuRolePermissionApi = createApi({
    reducerPath: "base/menuRolePermission",
    baseQuery: axiosBaseQuery,
    tagTypes: ["menuRolePermissionList"],
    endpoints: (builder) => ({
        menuRolePermissionFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['menuRolePermissionList'],
            query: (query = '') => ({
                url: "/base/menuRolePermission" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        menuRolePermissionCreate: builder.mutation({
            invalidatesTags: ['menuRolePermissionList'],
            query: (data) => ({ url: "/base/menuRolePermission", method: "POST", data })
        }),
        menuRolePermissionUpdate: builder.mutation({
            invalidatesTags: ['menuRolePermissionList'],
            query: (data) => ({ url: "/base/menuRolePermission/" + data.id, method: "PUT", data })
        }),
        menuRolePermissionDelete: builder.mutation({
            invalidatesTags: ['menuRolePermissionList'],
            query: (id) => ({ url: "/base/menuRolePermission/" + id, method: "DELETE" })
        }),
        menuRolePermissionReplace: builder.mutation({
            invalidatesTags: ["menuRolePermissionList"],
            query: ({ role_id, menu_id, permissionIds }: { role_id: string; menu_id: number; permissionIds: number[] }) => ({
                url: `/base/menuRolePermission/replace`,
                method: "POST",
                data: { role_id, menu_id, permissionIds },
            }),
        }),
    })
})

export const { useMenuRolePermissionFindAllQuery, useMenuRolePermissionCreateMutation, useMenuRolePermissionUpdateMutation, useMenuRolePermissionDeleteMutation, useMenuRolePermissionReplaceMutation, } = menuRolePermissionApi;
export { menuRolePermissionApi };
